import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomDropdown, CustomModal } from '../../../../components'
import * as DeliveryHttp from '../../../../services/api/https/deliveries/delivery.http'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { DateTime } from 'luxon'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE: 'Alterando status de entrega',
  SUCCESS: 'Status da entrega alterado com sucesso',
}

const DELIVERY_STATUS = [
  { value: '8', label: 'Entregue' },
  { value: '9', label: 'Devolução Total' },
  { value: '10', label: 'Devolução Parcial' },
  { value: '12', label: 'Reentrega' },
]

const INITIAL_STATE = {
  delivery: {
    delivery_step_id: 0,
    delivery_id: 0,
    identifier: '0',
    invoice_number: null,
    nomeFantasia: '',
    city: '',
    address: '',
    district: '',
    cnpj: '',
    qteSkuTotal: 0,
    status: '',
    dt_status: '',
    path_canhoto: null,
    path_nf_dev_total: null,
  },
  selectedValue: 0,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}
const { id: user_id } = getUsuarioInfo()

function ModalAlterarStatus({ data, show, onModalClose, onModalSave, dispatch }) {
  // Hooks
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (data) {
      setState(prevState => {
        prevState.delivery = data
        const index = DELIVERY_STATUS.findIndex(
          status => status.label === prevState.delivery.status,
        )
        if (index !== -1) prevState.selectedValue = DELIVERY_STATUS[index].value
        else {
          dispatch(showMessageBox(null, 'Esse status não é valido para alteração'))
          onModalClose()
        }
        return { ...prevState }
      })
    }
  }, [data])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        const index = DELIVERY_STATUS.findIndex(status => status.label === state.delivery.status)
        const old_status_id = DELIVERY_STATUS[index].value
        alterarStatusEntrega(
          state.delivery.delivery_step_id,
          user_id,
          old_status_id,
          state.selectedValue,
        )
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.delivery)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  const alterarStatusEntrega = (delivery_step_id, user_id, old_status_id, new_status_id) => {
    DeliveryHttp.alterarStatusDeEntrega(delivery_step_id, user_id, old_status_id, new_status_id)
      .then(updatedStatus => {
        setState(prevState => {
          prevState.delivery.status = updatedStatus.status
          prevState.delivery.dt_status = DateTime.fromFormat(
            updatedStatus.dt_status,
            'dd-MM-yyyy',
          ).toISO()
          prevState.loadingMessage = LOAD_MESSAGE.SUCCESS
          return { ...prevState }
        })
      })
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  // Events
  const onFormContentChange = value => {
    setState(prevState => {
      prevState.selectedValue = value
      return { ...prevState }
    })
  }

  const onBtnSalvarClicked = state => {
    const statusSelected = DELIVERY_STATUS.find(stat => stat.value === state.selectedValue)
    if (statusSelected.label !== state.delivery.status)
      setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE }))
    else dispatch(showMessageBox(null, 'Esse ja é o status atual da entrega, selecione outro.'))
  }

  // Render
  return (
    <CustomModal
      header="Entregas por Empresa - Alterar status"
      isVisible={show}
      onClose={onModalClose}
    >
      <form className="p-grid">
        <div className="p-col-12">
          <CustomDropdown
            label="Alterar o status de entrega para:"
            options={DELIVERY_STATUS}
            value={state.selectedValue}
            onChange={value => onFormContentChange(value)}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={() => onBtnSalvarClicked(state)}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}
export default connect()(ModalAlterarStatus)
